// extracted by mini-css-extract-plugin
module.exports = {"container":"NewsDetail_container__X8sUI","time":"NewsDetail_time__gfBWA","article":"NewsDetail_article__27XNR"};